import validate from "/codebuild/output/src2768984684/src/node_modules/nuxt/dist/pages/runtime/validate.js";
import return_45global from "/codebuild/output/src2768984684/src/nuxt/middleware/return.global.js";
import slash_45global from "/codebuild/output/src2768984684/src/nuxt/middleware/slash.global.ts";
import manifest_45route_45rule from "/codebuild/output/src2768984684/src/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  return_45global,
  slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}